import { configureStore } from "@reduxjs/toolkit";
import { api } from "common-components";
import { apiLocal } from "../app/services/baseApiSetup.js";
import filterSlice from "./common-components/CommonFilter/complainceFilterSlice.js";
import ComplianceMainFilterSlice from "./common-components/CommonFilter/ComplianceMainFilterSlice.js";
import commonSlice from "./commonSlice";

import observabilitySlice from "../DevopsInsights/observabilitySlice";

// ==================== HOME MODULE SLICES ====================
import HomeApiSlice from "../Modules/Home/HomeApiSlice.js";
import HomeSlice from "../Modules/Home/HomeSlice.js";

// ==================== GOVERNANCE AND COMPLIANCE SLICES ====================
import { CISOSBOMSlice, SBOMSlice } from "common-components";
import CISBenchmarkSlice from "../Modules/governance-and-compliance/Compliance/CISBenchmarkCompliance/CISBenchmarkSlice";
import summarySlice from "../Modules/governance-and-compliance/Compliance/Summary/SummarySlice.js";
import VulnerabilitiesSlice from "../Modules/governance-and-compliance/Compliance/Vulnerabilites/VulnerabilitiesSlice";
import SecurityHubSlice from "../Modules/governance-and-compliance/Compliance/securityHub/SecurityHubSlice";
import AssetCoverageSlice from "../Modules/governance-and-compliance/Compliance/AssetsCoverage/slice/AssetCoverageSlice";
import piiUserBarSlice from "../Modules/governance-and-compliance/GNCSlice.js";
import LicenseSlice from "../Modules/governance-and-compliance/LicenseManagement/LicenseSlice";

import BSPSlice from "../Modules/governance-and-compliance/RegulatoryCompliance/BSPCompliance/slices/BSPSlice.js";
import RMiTSlice from "../Modules/governance-and-compliance/RegulatoryCompliance/RMiT/slices/RMiTSlice.js";
import TRMGSlice from "../Modules/governance-and-compliance/RegulatoryCompliance/TRMG/slices/TRMGSlice.js";
import Circular9Slice from "../Modules/governance-and-compliance/RegulatoryCompliance/circular9/slices/Circular9Slice.js";
import IM8Slice from "../Modules/governance-and-compliance/RegulatoryCompliance/IMI8/slices/IM8Slice.js";
import RegulatoryOverviewSlice from "../Modules/governance-and-compliance/RegulatoryCompliance/slices/RegulatoryOverviewSlice.js";
import CISOSlice from "../Modules/governance-and-compliance/cisoDashboard/CisoSlice";

// ==================== CLOUD INSIGHTS SLICES ====================
import architecureComplianceSlice from "../Modules/CloudInsights/ArchitectureCompliance/Compliance/pages/ArchitectureComplianceSlice.js";
import configurationFilterSlice from "../Modules/CloudInsights/ArchitectureCompliance/Compliance/pages/ConfigurationFilterSlice.jsx";
import reviewslice from "../Modules/CloudInsights/CloudAccessGovernance/AccessReview/pages/reviewslice.js";
import userReviewSlice from "../Modules/CloudInsights/CloudAccessGovernance/AccessReview/pages/userReviewSlice.js";
import UARGraphSlice from "../Modules/CloudInsights/CloudAccessGovernance/UserGraphs/UserGraphSlice.js";
import CloudfilterSlice from "../Modules/CloudInsights/CloudCostInsights/CommonFilter/complainceFilterSlice.js";
import CostSlice from "../Modules/CloudInsights/CloudCostInsights/pages/CostSlice";
import CloudCostsummarySlice from "../Modules/CloudInsights/CloudCostInsights/summarycharts/SummarySlice.js";
import ResilenceSlice from "../Modules/CloudInsights/Resilency/ResilenceSlice.js";

// ==================== SIRAR =====================
import SirarfilterSlice from "../Modules/SirarModule/Sirar/MainSlice.js";
import LogApproverSlice from "../Modules/SirarModule/SirarCiso/CISOSlice.js";
import LogReviewerSlice from "../Modules/SirarModule/SirarTLReview/CISOSlice.js";
// ==================== CONFIGURATION SLICES ====================
import {
  appConfigSlice,
  AssetSlice,
  AuditLogSlice,
  BudgetSlice,
  CBudgetSlice,
  CMDBSlice,
  configurationSlice,
  efficiencySlice,
  GoLiveSlice,
  OrgInfoSlice,
  ProjectsSlice,
} from "common-components";

// ==================== ADMINISTRATION SLICES ====================
import {
  CloudCostConfigSlice,
  DataImportConfigSlice,
  EmailScheduleConfigSlice,
  GroupSlice,
  PIIConfigurationSlice,
  PolicyPriviledgeSlice,
  RiskassessmentSlice,
  StatePriviledgeSlice,
  ToolsSlice,
} from "common-components";


export const store = configureStore({
  reducer: {
    // Base API
    [api.reducerPath]: api.reducer,
    [apiLocal.reducerPath]: apiLocal.reducer,
    // Common slices
    common: commonSlice,
    filterApi: filterSlice,
    ComplianceMainFilterApi: ComplianceMainFilterSlice,
    // ========== HOME MODULE ==========
    Homedata: HomeSlice,
    HomeApiCall: HomeApiSlice,

    // ========== DEVOPS INSIGHTS ==========
    observability: observabilitySlice,

    // ========== GOVERNANCE AND COMPLIANCE ==========
    Name: piiUserBarSlice,
    LicenseApiCall: LicenseSlice,
    vulnerabilityApi: VulnerabilitiesSlice,
    SecurityHubApi: SecurityHubSlice,
    CisBenchmark: CISBenchmarkSlice,
    summaryapi: summarySlice,
    AssetCoverageApi: AssetCoverageSlice,
    TRMGSliceApi: TRMGSlice,
    BSPSliceApi: BSPSlice,
    RMiTSliceApi: RMiTSlice,
    Circular9Api: Circular9Slice,
    IM8Api: IM8Slice,
    RegulatoryOverviewApi: RegulatoryOverviewSlice,
    CISOSliceAPI: CISOSlice,
    SBOMSliceAPI: SBOMSlice.reducer,
    CISOSBOMSliceAPI: CISOSBOMSlice.reducer,

    // ========= SIRAR ===========
    SirarfilterSlice: SirarfilterSlice,
    LogReviewerSlice: LogReviewerSlice,
    LogApproverSlice: LogApproverSlice,

    // ========== CLOUD INSIGHTS ==========
    cloudCostApi: CostSlice,
    CloudfilterApi: CloudfilterSlice,
    CCIsummaryApi: CloudCostsummarySlice,
    AwsArchitectureData: architecureComplianceSlice,
    ConfigurationFilterApi: configurationFilterSlice,
    userReviewData: userReviewSlice,
    UARGraphData: UARGraphSlice,
    reviewApi: reviewslice,
    ResilenceData: ResilenceSlice,

    // ========== CONFIGURATION ==========
    configuration: configurationSlice,
    efficiency: efficiencySlice,
    appConfig: appConfigSlice,
    cmdbId: CMDBSlice,
    assetApi: AssetSlice,
    CBudgetApi: CBudgetSlice,
    BudgetApi: BudgetSlice,
    GoLiveApi: GoLiveSlice,
    OrganizationInformation: OrgInfoSlice,
    projectsapi: ProjectsSlice,

    // ========== ADMINISTRATION ==========
    toolsApi: ToolsSlice,
    PIIConfigurationSlice: PIIConfigurationSlice,
    PolicyPriviledgeSliceAPI: PolicyPriviledgeSlice,
    StatePriviledgeSliceAPI: StatePriviledgeSlice,
    RiskassessmentSliceAPI: RiskassessmentSlice,
    CloudCostConfigApi: CloudCostConfigSlice,
    GroupApi: GroupSlice,
    EmailSchduleConfiguration: EmailScheduleConfigSlice,
    DataImportConfig: DataImportConfigSlice,

    // ========== SETTINGS ==========
    AuditLogApi: AuditLogSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(api.middleware).concat(apiLocal.middleware),
});
